import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, OnDestroy, OnInit, ViewChild} from '@angular/core';

 
import {Observable, of, from} from "rxjs";
import {MaterialInstance, MaterialService} from "../../shared/classes/material.service";
import {Subscription} from "rxjs";
import {StreamsService}  from "../../shared/services/streams.service";
import {StreamProject} from "../../shared/interfaces";
import { switchMap, delay} from 'rxjs/operators';
import { ActivatedRoute, Router} from '@angular/router';
import {SocketStreamsWatch, socketEvents} from '../../shared/services/sockets'
import {WatchVideoPlayerComponent} from '../../shared/components/watch-video-player/watch-video-player.component'
import {WatchTokenService}  from "../../shared/services/watch-token.service";

 
@Component({
  selector: 'app-watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss'],
 
})
export class WatchComponent {


  @ViewChild('video') videoComponent:any ;
  hasCounter: boolean;
  @Input() stream: StreamProject
  @Input() isEmbed: boolean

  @Output() onTokenClose =  new EventEmitter()
  @Output() onExceededLimit =  new EventEmitter()
 sessionKey;
  constructor(
    public streamsService: StreamsService,
     public tokenService: WatchTokenService,

    private socket: SocketStreamsWatch,
    private router: Router

    ){

    //this.socket.removeAllListeners()
    //  this.socket.disconnect()
  } 
  
  stream$:Observable<StreamProject>
  source: string | boolean = true
  cdnLabel: string = ''
  chatOpened: boolean = true
  

  ngOnInit() {  
     this.sessionKey = this.stream.session.local_session_id

	this.hasCounter = this.stream.counter?.start
    this.connectSocket(
        {
          publicIdentity: this.stream.publicIdentity,
          ud:this.stream.user,
          token: this.tokenService.getToken(this.stream.publicIdentity) || false,
	  type: this.stream.type
          
        }
      )
            
 	//console.log(this.sessionKey)
  }



  connectSocket(data){

    this.socket.on('streamStatusChanged', this.streamStatusChanged.bind(this))
    this.socket.on('exitByToken', this.exitByToken.bind(this))
    this.socket.on('onSource', this.onSource.bind(this))
    this.socket.on('onWatchersExceededLimit', this.onWatchersExceededLimit.bind(this))
    
    this.socket.on('refresh', ()=>{window.location.reload()})
    this.socket.on('connect', ()=>{
      this.socket.emit('onJoin', 
       {
        data 
        }
      )
    })

    this.socket.connect()
  }

  counterOnDone(){

	this.hasCounter = false

	setTimeout(()=>{
	   if(this.videoComponent){
		    this.videoComponent.setSource(
			{ src: this.source ,
			type: 'application/x-mpegURL'} 
		    ) 
		this.videoComponent.play()

		if(this.stream.isRunning){
			this.videoComponent.streamStarted()
		}
		}else{
		location.reload()
		}
	},1000)
 }

  onSource(data){
//

var index = 'index.m3u8' //+'?'+(new Date().getTime())
	/* if(this.stream._id === '607de344d2ad6062913f90e8'){
		  index = 'dash.mpd'
               // index = 'i.m3u'
	} */

      this.cdnLabel = data.cdnLabel
    this.source =    data.src+'/'+this.stream.streamKey.substr(0, this.stream.streamKey.length -10)+'/'+index 
   if(this.stream._id === '607de344d2ad6062913f90e8'){
    this.source =    data.src+'/2.mp4'
               // index = 'i.m3u'
	}

   if(this.videoComponent){
	    this.videoComponent.setSource(
		{ src: this.source ,
		type: 'application/x-mpegURL'} 
	    ) 
	}
  }

  //onSource

  exitByToken(data){
  
         this.onTokenClose.emit(data)
 
      
  }

  onWatchersExceededLimit(){

	//console.log('onWatchersExceededLimit')
	//this.router.navigate(['/watchers-exceeded-limit'])
 

       this.onExceededLimit.emit(true)


  }

  streamStatusChanged(data){
    // console.log(data)
    if(data?.type === socketEvents.streamStarted){

	this.stream.isRunning = true
  
     /* setTimeout(()=>{
        this.videoComponent.start()
      },10000) */

	if(this.hasCounter){
	   this.counterOnDone()
	   return
	}

	 this.videoComponent?.streamStarted()
     return
    }
    if(data?.type === socketEvents.streamStoped){
  	this.stream.isRunning = false
	this.videoComponent?.streamStoped()
     return
    }
   }
 

   toggleChatOpen(){
     this.chatOpened = !this.chatOpened
   }
 
   ngOnDestroy() { 
 
    this.socket.disconnect()
     // this.socket.removeAllListeners()

	/**/ this.socket.removeAllListeners('streamStatusChanged')
	this.socket.removeAllListeners('exitByToken')
	this.socket.removeAllListeners('onSource')
	this.socket.removeAllListeners('refresh')
	this.socket.removeAllListeners('connect')
	this.socket.removeAllListeners('onWatchersExceededLimit')

  

   }


}
